module.exports = __webpack_public_path__ + "img/192.f9d3004c.jpg";